const UUID_REGEX =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isUUID(uuid?: string) {
    if (!uuid) return false;

    return UUID_REGEX.test(uuid);
}
